import { Menu } from "lucide-react";

const SupportHeader = ({onMenuClick}) => {
  return (
    <div className="support-header">
      <Menu className="menu-btn " onClick={onMenuClick} />
      <div>
         <h1>Partner Support</h1>
         <p>Get help and find answers to your questions</p>
    </div>
    </div>
  );
};

export default SupportHeader;
